<div class="tag-input-container border rounded p-2">
    <span *ngFor="let tag of tags; let i = index"
        class="badge bg-secondary tag-badge me-1 mb-1">
        {{ tag }}
        <button *ngIf="!disable"
            type="button"
            class="btn-close btn-close-white ms-1"
            aria-label="Remove"
            (click)="removeTag(i)">
        </button>
    </span>

    <input *ngIf="!disable"
        type="text"
        class="tag-text-input"
        [placeholder]="placeholder"
        [(ngModel)]="inputValue"
        (keydown)="onKeydown($event)"
        (blur)="onTouched()"/>
</div>
